import { render, staticRenderFns } from "./outsource.vue?vue&type=template&id=10f894c7&scoped=true&"
import script from "./outsource.vue?vue&type=script&lang=js&"
export * from "./outsource.vue?vue&type=script&lang=js&"
import style0 from "./outsource.vue?vue&type=style&index=0&id=10f894c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f894c7",
  null
  
)

export default component.exports